var _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg022SgCarrierScorecards = function Svg022SgCarrierScorecards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0eda2",
    d: "M312 372c0-55.915 38.243-102.898 90-116.219A120.217 120.217 0 0 0 372 252c-66.274 0-120 53.726-120 120s53.726 120 120 120c10.359 0 20.411-1.313 30-3.781-51.757-13.321-90-60.304-90-116.219z",
    "data-original": "#cee1f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14d64d",
    d: "M376 76h-40c-11.046 0-20 8.954-20 20s8.954 20 20 20h40c11.028 0 20 8.972 20 20v40c0 11.046 8.954 20 20 20s20-8.954 20-20v-40c0-33.084-26.916-60-60-60z",
    "data-original": "#ff5cf4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#005454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.23 188.083c9.821 9.822 22.88 15.23 36.77 15.23s26.948-5.409 36.77-15.231l11.313-11.313c9.822-9.822 15.231-22.88 15.231-36.77s-5.409-26.948-15.231-36.77L176.77 91.917c-9.821-9.822-22.88-15.23-36.77-15.23s-26.948 5.409-36.77 15.231L91.917 103.23c-9.822 9.822-15.231 22.88-15.231 36.77s5.409 26.948 15.231 36.77zm16.971-56.568 11.313-11.314c2.267-2.267 5.28-3.515 8.485-3.515s6.219 1.248 8.485 3.515l11.313 11.314c2.267 2.266 3.515 5.28 3.515 8.485s-1.249 6.219-3.515 8.485l-11.313 11.314c-2.267 2.267-5.28 3.515-8.485 3.515s-6.219-1.248-8.485-3.515l-11.313-11.314c-2.267-2.266-3.515-5.28-3.515-8.485s1.249-6.219 3.515-8.485z",
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 332,
    r: 20,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412,
    cy: 412,
    r: 20,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.857 317.858-80 80c-7.811 7.811-7.811 20.474 0 28.284 7.81 7.81 20.474 7.811 28.285 0l80-80c7.811-7.811 7.811-20.474 0-28.284s-20.474-7.811-28.285 0z",
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 232c-77.196 0-140 62.804-140 140s62.804 140 140 140 140-62.804 140-140-62.804-140-140-140zm0 240c-55.141 0-100-44.86-100-100s44.859-100 100-100 100 44.86 100 100-44.859 100-100 100zM140 280c77.196 0 140-62.804 140-140S217.196 0 140 0 0 62.804 0 140s62.804 140 140 140zm0-240c55.14 0 100 44.86 100 100s-44.86 100-100 100S40 195.14 40 140 84.86 40 140 40zM96 316c-11.046 0-20 8.954-20 20v40c0 33.084 26.916 60 60 60h40c11.046 0 20-8.954 20-20s-8.954-20-20-20h-40c-11.028 0-20-8.972-20-20v-40c0-11.046-8.954-20-20-20z",
    "data-original": "#0023c4"
  }))));
};

export default Svg022SgCarrierScorecards;